import { render, staticRenderFns } from "./upperlist.html?vue&type=template&id=923e0e68&external"
import script from "./upperlist.vue?vue&type=script&lang=js"
export * from "./upperlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports